/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AcceptedBidDto } from '../models/accepted-bid-dto';
import { createAcceptedBid } from '../fn/accepted-bid/create-accepted-bid';
import { CreateAcceptedBid$Params } from '../fn/accepted-bid/create-accepted-bid';
import { deleteAcceptedBid } from '../fn/accepted-bid/delete-accepted-bid';
import { DeleteAcceptedBid$Params } from '../fn/accepted-bid/delete-accepted-bid';

@Injectable({ providedIn: 'root' })
export class GeneratedAcceptedBidService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `createAcceptedBid()` */
  static readonly CreateAcceptedBidPath = '/api/accepted-bids';

  /**
   * Creates a new accepted-bid.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createAcceptedBid()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createAcceptedBid$Response(params: CreateAcceptedBid$Params, context?: HttpContext): Observable<StrictHttpResponse<AcceptedBidDto>> {
    return createAcceptedBid(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new accepted-bid.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createAcceptedBid$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createAcceptedBid(params: CreateAcceptedBid$Params, context?: HttpContext): Observable<AcceptedBidDto> {
    return this.createAcceptedBid$Response(params, context).pipe(
      map((r: StrictHttpResponse<AcceptedBidDto>): AcceptedBidDto => r.body)
    );
  }

  /** Path part for operation `deleteAcceptedBid()` */
  static readonly DeleteAcceptedBidPath = '/api/accepted-bids/{id}';

  /**
   * Withdraws an existing accepted-bid.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteAcceptedBid()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAcceptedBid$Response(params: DeleteAcceptedBid$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteAcceptedBid(this.http, this.rootUrl, params, context);
  }

  /**
   * Withdraws an existing accepted-bid.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteAcceptedBid$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAcceptedBid(params: DeleteAcceptedBid$Params, context?: HttpContext): Observable<void> {
    return this.deleteAcceptedBid$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
